// export const assertThaiId = (thaiId: string) => {
//   const THAI_13_DIGIT_REGEX = '^([0-9]{13})+$';
//   const FRAGMENT_LAST_DIGIT_REGEX = /(\d{12})(\d)/;
//
//   const is13Digit = thaiId.match(THAI_13_DIGIT_REGEX);
//   if (!is13Digit) {
//     return false;
//   }
//
//   const fragmentStr = thaiId.match(FRAGMENT_LAST_DIGIT_REGEX);
//   if (!fragmentStr || fragmentStr?.length === 0) {
//     return false;
//   }
//
//   const digits = fragmentStr[1].split('');
//   const Initial = 0;
//   const totalSum = digits?.reduce((total, digit, index) => {
//     return total + (13 - index) * +digit;
//   }, Initial);
//
//   if (!totalSum) {
//     return false;
//   }
//
//   const checkSumCal = (11 - (totalSum % 11)) % 10;
//   const lastDigit = fragmentStr[2];
//
//   return `${checkSumCal}` === lastDigit;
// };
export const assertThaiId = (thaiId?: string): boolean => {
  // กัน null/undefined และเก็บเฉพาะตัวเลข
  const id = String(thaiId ?? '').replace(/\D/g, '');

  // ต้องเป็นตัวเลข 13 หลัก
  if (id.length !== 13) return false;

  // คำนวณ checksum ตามสูตรบัตรประชาชนไทย
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number(id[i]) * (13 - i);
  }
  const checkDigit = (11 - (sum % 11)) % 10;
  return checkDigit === Number(id[12]);
};
